import React from 'react';

interface ScoreProgressBarProps {
  label: string;
  value: number | null | undefined;
  max: number;
  valueLabel?: string;
  barColor?: string;
}

const ScoreProgressBar: React.FC<ScoreProgressBarProps> = ({
  label,
  value,
  max,
  valueLabel,
  barColor = 'bg-primary',
}) => {
  const num = value != null ? Math.min(max, Math.max(0, Number(value))) : 0;
  const pct = max > 0 ? (num / max) * 100 : 0;
  const display = valueLabel ?? (value != null ? `${num}/${max}` : '—');

  return (
    <div className="space-y-1">
      <div className="flex justify-between text-sm">
        <span className="font-medium text-foreground">{label}</span>
        <span className="text-muted-foreground tabular-nums">{display}</span>
      </div>
      <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
        <div
          className={`h-full rounded-full transition-[width] ${barColor}`}
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={num}
          aria-valuemin={0}
          aria-valuemax={max}
        />
      </div>
    </div>
  );
};

export default ScoreProgressBar;
